export default "__VITE_ASSET__720569a4__"